// React Query configuration. One-shot reads + focus/interval revalidation —
// zero Firestore listeners (see src/firebase.ts). The cache persists to
// localStorage so My Shifts renders offline with an "as of" banner.
import { QueryClient } from '@tanstack/react-query'
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister'
import { persistQueryClient } from '@tanstack/react-query-persist-client'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: 2,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      gcTime: 24 * 3600_000,
    },
  },
})

if (typeof window !== 'undefined') {
  const persister = createSyncStoragePersister({
    storage: window.localStorage,
    key: 'callboard-query-cache',
  })
  persistQueryClient({
    queryClient,
    persister,
    maxAge: 24 * 3600_000,
    dehydrateOptions: {
      // Persist only employee-surface reads that matter offline.
      shouldDehydrateQuery: (q) =>
        ['myShifts', 'teamWeek', 'reference'].includes(String(q.queryKey[0])),
    },
  })
}
